import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import {useTranslation} from "react-i18next";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import Grid from '@mui/material/Grid';
import {observer} from 'mobx-react';
import React from 'react';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {TAB_OTHER, TAB_TRIP} from './StatsCommon.js';
import TripSelect from '../TripSelect.js';
import {getSpecName} from '../Trans.js'
import {COMM_OK} from '../WsR2.js';

const TSO_KEY		= 0;
const TSO_SPEC		= 1
const TSO_CNT		= 2;
const TSO_NUM		= 3;

const TSO_DESC		= 0;
const TSO_ASC		= 1;

const StatsTrip = observer((props) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	function statsTripGetSpecName(id) {
		return getSpecName(gStorage.lists.speclist.list.find(elem => elem.id === id), gStorage.conn.user);
	}

	function tripChange(event) {
		gStorage.stats.setTrip(parseInt(event.target.value, 10));
		gStorage.stats.setObsList(null);
	}

	function tripStatsRxWs(status, msg) {
		if (status !== COMM_OK) {
			alert('tripStatsRxWs: error ' + status);
			return;
		} else if (msg.result !== 'OK') {
			alert('tripStatsRxWs: ' + msg.data.desc + '!');
			return;
		}

		if (gStorage.stats.tab !== TAB_OTHER || gStorage.stats.other_tab !== TAB_TRIP)
			return;

// 		console.log('tripStatsRxWs', msg);
		
		const ts = msg.data.stats[0].taxons.reverse();
		ts.forEach((ti, i) => {
			ti.key = msg.data.stats[0].taxons.length - i - 1;
		});

		gStorage.stats.setObsList(ts);
		gStorage.stats.setTripOrder(TSO_KEY, TSO_DESC);
	}

	function loadTripStats() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'trip',
			op: 'stats',
			data: {
				id: [gStorage.stats.trip]
			}
		}
// 		console.log('loadTripStats', msg);
		gStorage.conn.ws.send(msg, tripStatsRxWs);
	}

	function sortByKey() {
		if (!gStorage.stats.obsList || gStorage.stats.obsList.length <= 0)
			return;

		const ts = gStorage.stats.obsList.slice();
		let dir = TSO_DESC;

		if (gStorage.stats.trip_sort_order === TSO_KEY)
			dir = gStorage.stats.trip_sort_dir === TSO_DESC ? TSO_ASC : TSO_DESC;

		gStorage.stats.setTripOrder(TSO_KEY, dir);

		ts.sort((a, b) => {
			if (dir === TSO_DESC)
				return b.key - a.key;

			return a.key - b.key;
		});

		gStorage.stats.setObsList(ts);
	}

	function sortBySpec() {
		if (!gStorage.stats.obsList || gStorage.stats.obsList.length <= 0)
			return;

		const ts = gStorage.stats.obsList.slice();
		let dir = TSO_ASC;

		if (gStorage.stats.trip_sort_order === TSO_SPEC)
			dir = gStorage.stats.trip_sort_dir === TSO_ASC ? TSO_DESC : TSO_ASC;

		gStorage.stats.setTripOrder(TSO_SPEC, dir);

		ts.sort((a, b) => {
			const a_name = statsTripGetSpecName(a.id);
			const b_name = statsTripGetSpecName(b.id);

			if (dir === TSO_DESC)
				return b_name.localeCompare(a_name, 'fi');

			return a_name.localeCompare(b_name, 'fi');
		});

		gStorage.stats.setObsList(ts);
	}

	function sortByCount() {
		if (!gStorage.stats.obsList || gStorage.stats.obsList.length <= 0)
			return;

		const ts = gStorage.stats.obsList.slice();
		let dir = TSO_DESC;

		if (gStorage.stats.trip_sort_order === TSO_CNT)
			dir = gStorage.stats.trip_sort_dir === TSO_DESC ? TSO_ASC : TSO_DESC;

		gStorage.stats.setTripOrder(TSO_CNT, dir);

		ts.sort((a, b) => {
			const ret = dir === TSO_DESC ? b.cnt - a.cnt : a.cnt - b.cnt;

			if (ret !== 0)
				return ret;			

			const a_name = statsTripGetSpecName(a.id);
			const b_name = statsTripGetSpecName(b.id);

			return a_name.localeCompare(b_name, 'fi');
		});

		gStorage.stats.setObsList(ts);
	}

	function sortByNum() {
		if (!gStorage.stats.obsList || gStorage.stats.obsList.length <= 0)
			return;

		const ts = gStorage.stats.obsList.slice();
		let dir = TSO_DESC;

		if (gStorage.stats.trip_sort_order === TSO_NUM)
			dir = gStorage.stats.trip_sort_dir === TSO_DESC ? TSO_ASC : TSO_DESC;

		gStorage.stats.setTripOrder(TSO_NUM, dir);

		ts.sort((a, b) => {
			const ret = dir === TSO_DESC ? b.num - a.num : a.num - b.num;

			if (ret !== 0)
				return ret;			

			const a_name = statsTripGetSpecName(a.id);
			const b_name = statsTripGetSpecName(b.id);

			return a_name.localeCompare(b_name, 'fi');
		});

		gStorage.stats.setObsList(ts);
	}

	function sortSignKey() {
		if (!gStorage.stats.obsList || gStorage.stats.obsList.length <= 0)
			return '';

		if (gStorage.stats.trip_sort_order !== TSO_KEY)
			return '';

		return gStorage.stats.trip_sort_dir === TSO_DESC ? ' ↓' : ' ↑';
	}

	function sortSignSpec() {
		if (!gStorage.stats.obsList || gStorage.stats.obsList.length <= 0)
			return '';

		if (gStorage.stats.trip_sort_order !== TSO_SPEC)
			return '';

		return gStorage.stats.trip_sort_dir === TSO_DESC ? ' ↓' : ' ↑';
	}

	function sortSignCnt() {
		if (!gStorage.stats.obsList || gStorage.stats.obsList.length <= 0)
			return '';

		if (gStorage.stats.trip_sort_order !== TSO_CNT)
			return '';

		return gStorage.stats.trip_sort_dir === TSO_DESC ? ' ↓' : ' ↑';
	}

	function sortSignNum() {
		if (!gStorage.stats.obsList || gStorage.stats.obsList.length <= 0)
			return '';

		if (gStorage.stats.trip_sort_order !== TSO_NUM)
			return '';

		return gStorage.stats.trip_sort_dir === TSO_DESC ? ' ↓' : ' ↑';
	}

	if (gStorage.stats.tab !== TAB_OTHER || gStorage.stats.other_tab !== TAB_TRIP)
		return null;

	if (!gStorage.stats.obsList && gStorage.stats.trip && gStorage.conn.online)
		loadTripStats();

	const ct = gStorage.stats.obsList && gStorage.stats.trip && gStorage.stats.obsList.length > 0 ? 'pointer' : 'default';

	return (
		<div>
			<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
				<Grid size={{xs: 12}} align={'center'}>
					<TripSelect trip={gStorage.stats.trip} tripChange={tripChange} enabled={gStorage.conn.online}/>
				</Grid>
			</Grid>
			<TableContainer component={Paper} elevation={0}>
				<Table size='small'>
					<TableHead>
						<TableRow>
							<TableCell align='center' padding='checkbox' sx={{cursor: ct, minWidth: 24}} onClick={sortByKey}>{'#' + sortSignKey()}</TableCell>
							<TableCell align='left' sx={{cursor: ct}} onClick={sortBySpec}>{t('main.species') + sortSignSpec()}</TableCell>
							<TableCell align='right' padding='checkbox' sx={{cursor: ct, minWidth: 32}} onClick={sortByCount}>{t('taxons.count2') + sortSignCnt()}</TableCell>
							<TableCell align='right' padding='checkbox' sx={{cursor: ct, minWidth: 32}} onClick={sortByNum}>{t('taxons.num2') + sortSignNum()}</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{gStorage.stats.obsList && gStorage.stats.obsList.slice().map((ti, i) => {
							return (<TableRow key={ti.key + 1}>
									<TableCell align='center' padding='checkbox'>{ti.key + 1}</TableCell>
									<TableCell align='left' >{statsTripGetSpecName(ti.id)}</TableCell>
									<TableCell align='right' padding='checkbox' style={{minWidth: 64}}>{ti.cnt}</TableCell>
									<TableCell align='right' padding='checkbox' style={{minWidth: 64}}>{ti.num}</TableCell>
								</TableRow>);
						})}
					</TableBody>
				</Table>
			</TableContainer>
		</div>
	);
});

export default StatsTrip;
